import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Pagination,
  Button,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import ExportDropdown from "../../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../../components/CustomText";
import StatusDropdown from "../../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import tablefilter from "../../../../assets/tablefilter.svg";
import { showUnderDevelopment } from "../../../../components/Alert";
import AddPayrollDrawer from "./AddDrawer";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import { useTheme } from "../../../../contexts/ThemeContext";
import DetailsDrawer from "./DetailsDrawer";
import emptypayment from "../../../../assets/emptypayment.png";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import PayrollFilterDrawer from "./filterDrawer.js";
import ExportPayrollExcel from "./payrollExcel.js";
import ExportPayrollPDF from "./payrollPdf.js";
import { pdf } from "@react-pdf/renderer";
import { useCompanyProfile } from "../../../../components/CompanyProfile";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils.js";
// ---------- helpers
const headerStyle = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const dataStyle = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const usd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    Number(n || 0)
  );
const formatUTCDate = (value) => {
  const formatted = convertUTCToLocalDateTime(value, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });
  return formatted === "—" ? "-" : formatted;
};

/** Full https URLs from the API are used unchanged; only relative paths are prefixed with the API origin (BASE_URL without /api). */
const resolveProofUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const u = url.trim();
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith("//")) return `${window.location.protocol}${u}`;
  const origin = BASE_URL.replace(/\/api\/?$/i, "");
  return u.startsWith("/") ? `${origin}${u}` : `${origin}/${u}`;
};

const Payroll = () => {
  const { t } = useTranslation();
  const { primaryColor, secondaryColor, primaryTextColor, secondaryTextColor } = useTheme();
  const [rows, setRows] = useState([]);

  const [initialLoading, setInitialLoading] = useState(true); // loader for page mount
  const [tableLoading, setTableLoading] = useState(false); // loader for search/pagination

  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [addDrawerOpen, setAddDrawerOpen] = useState(false);

  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 5;

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
const [filters, setFilters] = useState({ type: "", startDate: "", endDate: "",  workerId: "",  });
  // ---- Fetch API


  const fetchData = async (page = 1, q = "", isInitial = false, appliedFilters = filters) => {
  try {
    if (isInitial) {
      setInitialLoading(true);
    } else {
      setTableLoading(true);
    }

    let filterQuery = "";
    if (appliedFilters.type) filterQuery += `&type=${appliedFilters.type}`;
    // if (appliedFilters.startDate) filterQuery += `&startDate=${appliedFilters.startDate}`;
    // if (appliedFilters.endDate) filterQuery += `&endDate=${appliedFilters.endDate}`;
    if (appliedFilters.startDate) filterQuery += `&from=${appliedFilters.startDate}`;
if (appliedFilters.endDate) filterQuery += `&to=${appliedFilters.endDate}`;

   if (appliedFilters.workerId)
  filterQuery += `&worker=${appliedFilters.workerId}`; 
       const url = `${BASE_URL}/company-admin/expenses/remuneration?q=${q}&page=${page}&page_size=${pageSize}&sort=-paid_at${filterQuery}`;


    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
    });

    const json = await res.json();
    console.log("json",json)
     if (!json.error && json.data) {
        const mapped = json.data.map((item) => ({
          id: item.id,
          workerName: item.worker?.name || "-",
          type: item.type === "salary" ? "Salary" : "Expense Reimbursement",
          amount: item.amount,
          paymentDate: formatUTCDate(item.paid_at),
          proof: !!item.attachment_url,
          attachmentUrl: item.attachment_url,
          status: "Paid", // update if API returns status
          comments: item.note || "-",
          currency: item.currency || item.expense?.currency || "USD",
          paymentMethod: item.payment_method || "-",  // ✅ add payment method
        }));

        setRows(mapped);
        setTotalPages(json.pagination?.pages || 1);
      }
  } catch (err) {
    console.error("Error fetching payroll:", err);
  } finally {
    if (isInitial) setInitialLoading(false);
    else setTableLoading(false);
  }
};

  useEffect(() => {
    fetchData(currentPage, searchTerm, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // fetch on pagination/search changes
  useEffect(() => {
    if (!initialLoading) {
      fetchData(currentPage, searchTerm, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchTerm]);

  const handleMenuOpen = (e, row) => {
    setAnchorEl(e.currentTarget);
    setSelectedRow(row);
  };
  const handleMenuClose = () => setAnchorEl(null);
const handleView = () => {
  setDrawerOpen(true);
  handleMenuClose();
};

const fetchAllPayroll = async () => {
  try {
    let url = `${BASE_URL}/company-admin/expenses/remuneration?no_pagination=true&q=${searchTerm}&sort=-paid_at`;

    if (filters.type) url += `&type=${filters.type}`;
    if (filters.startDate) url += `&from=${filters.startDate}`;
    if (filters.endDate) url += `&to=${filters.endDate}`;
    if (filters.workerId)
  url += `&worker=${filters.workerId}`;

    console.log("📡 Fetching ALL payroll:", url);

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${decryptedToken}` },
    });

    const json = await res.json();

    if (json.error) {
      console.error("❌ Error fetching payroll:", json.message);
      return [];
    }

    const mapped = (json.data || []).map((item) => ({
      id: item.id,
      workerName: item.worker?.name || "-",
      type: item.type === "salary" ? "Salary" : "Expense Reimbursement",
      amount: usd(item.amount),
      paymentDate: formatUTCDate(item.paid_at),
      proof: item.attachment_url || "-",
      status: "Paid",
      comments: item.note || "-",
    }));

    return mapped;

  } catch (err) {
    console.error("❌ Fetch all payroll failed:", err);
    return [];
  }
};

// ✅ Currency symbol helper
const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "";
  switch (currencyCode.toUpperCase()) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    default:
      return ""; // no text fallback if it's another currency
  }
};

const { logoBase64, loading } = useCompanyProfile(decryptedToken);
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        border: "2px solid #091E4224",
        py: 2,
        px: 0,
        ml: 1,
        mr: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
              textAlign: "left",
            }}
          >
            {t("payrollRecords.heading") || "Payroll Records"}
          </CustomText>
          {/* Table loader inline with heading */}
          {tableLoading && <CircularProgress size={20} />}
        </Box>

        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            placeholder={t("payrollRecords.searchPlaceholder") || "Search…"}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // reset to first page on new search
            }}
            sx={{
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              color: "#939393",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
        </Box>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <ExportDropdown
  onDownloadPDF={async () => {
    const allPayroll = await fetchAllPayroll();
    const blob = await pdf(<ExportPayrollPDF data={allPayroll} logo={logoBase64} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Payroll_Records ${new Date()
          .toISOString()
          .slice(0, 10)}.pdf`;
    link.click();
  }}
  onDownloadExcel={async () => {
    const allPayroll = await fetchAllPayroll();
    ExportPayrollExcel(allPayroll);
  }}
/>
          <Button
            onClick={() => setAddDrawerOpen(true)}
            variant="contained"
            size="small"
            sx={{
              px: 2,
              backgroundColor: primaryColor,
              color: primaryTextColor,
              height: 32,
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Poppins, sans-serif",
              borderRadius: "4px",
              textTransform: "none",
              '&:hover': {
                backgroundColor: secondaryColor,
                color: secondaryTextColor,
              },
              '& .MuiSvgIcon-root': {
                color: 'inherit',
              },
            }}
            startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          >
            {t("common.add") || "Add"}
          </Button>
        {filters.type || filters.startDate || filters.endDate || filters.workerId ?(
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: primaryColor,
    }}
  >
    <FilterAltIcon sx={{ color: primaryTextColor, fontSize: 20 }} />
    <IconButton
      size="small"
      onClick={() => {
        const resetFilters = { type: "", startDate: "", endDate: "",  workerId: "",  };
        setFilters(resetFilters);
        setCurrentPage(1);
        fetchData(1, searchTerm, false, resetFilters); // small loader
      }}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { 
          bgcolor: secondaryColor,
          color: secondaryTextColor,
        },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      "&:hover": {
        backgroundColor: primaryColor,
        color: primaryTextColor,
        "& .MuiSvgIcon-root": {
          color: primaryTextColor,
        },
      },
    }}
  >
    <FilterAltIcon />
  </IconButton>
)}
        </Box>
      </Box>

      {/* Main loader only on first mount */}
      {initialLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {/* Table */}
          <Box sx={{ overflowX: "auto", width: "100%" }}>
            <Table>
              <TableHead>
                <TableRow>
                
                  <TableCell sx={headerStyle}>{t("payroll.tableHeaders.id")}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.worker")}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.salary") || "Salary"}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.paymentDate")}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.paymentMethod") || "Payment Method"}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.proof")}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.status")}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.comments")}</TableCell>
<TableCell sx={headerStyle}>{t("payroll.tableHeaders.action")}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
  {rows.length > 0 ? (
    rows.map((row) => (
      <TableRow key={row.id}>
        <TableCell sx={dataStyle}>{row.id}</TableCell>
        <TableCell sx={dataStyle}>{row.workerName}</TableCell>
        {/* <TableCell sx={dataStyle}>{row.type}</TableCell> */}
        <TableCell sx={dataStyle}>
          {/* {usd(row.amount)} */}
  {getCurrencySymbol(row.currency)}{" "}{row.amount}
        </TableCell>
        <TableCell sx={dataStyle}>{row.paymentDate}</TableCell>
        <TableCell sx={dataStyle}>{row.paymentMethod || "-"}</TableCell>

        {/* <TableCell sx={dataStyle}>
          {row.proof ? (
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                size="small"
                onClick={() => window.open(row.attachmentUrl, "_blank")}
                sx={{
                  "&:hover": {
                    backgroundColor: primaryColor + '15',
                    color: primaryColor,
                  },
                }}
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
            </Box>
          ) : (
            "-"
          )}
        </TableCell> */}
        <TableCell sx={dataStyle}>
{row.proof ? (
<Box sx={{ display: "flex", gap: 1 }}>
<IconButton
size="small"
onClick={() => {
const href = resolveProofUrl(row.attachmentUrl);
if (href) window.open(href, "_blank", "noopener,noreferrer");
}}
sx={{
"&:hover": {
backgroundColor: primaryColor + "15",
color: primaryColor,
},
}}
>
<VisibilityIcon fontSize="small" />
</IconButton>
</Box>
) : (
"-"
)}
</TableCell>

        <TableCell sx={dataStyle}>
          <StatusDropdown currentStatus={row.status} />
        </TableCell>

        <TableCell sx={dataStyle} title={row.comments}>
          {row.comments}
        </TableCell>

        <TableCell>
          <IconButton
            size="small"
            onClick={(e) => handleMenuOpen(e, row)}
            sx={{
              "&:hover": {
                backgroundColor: primaryColor + '15',
                color: primaryColor,
              },
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={emptypayment}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box>
      </TableCell>
    </TableRow>
  )}
</TableBody>

            </Table>
          </Box>

          {/* Pagination */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              shape="rounded"
              color="primary"
              size="small"
              sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: 13,
                  fontWeight: 500,
                },
                "& .Mui-selected": {
                  backgroundColor: primaryColor + '20',
                  color: primaryColor,
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: secondaryColor + '15',
                  color: secondaryColor,
                },
              }}
            />
          </Box>
        </>
      )}

      {/* Row menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem
          onClick={handleView}
          sx={{ fontSize: 14, fontFamily: "Poppins, sans-serif" }}
        >
          {t("unvalidatedPunches.tableActions.view") || "View"}
        </MenuItem>
      </Menu>

      {/* Drawer */}
      <DetailsDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  remunerationId={selectedRow?.id}   // 👈 pass only the id
/>
      <AddPayrollDrawer
        open={addDrawerOpen}
        onClose={() => setAddDrawerOpen(false)}
          refreshList={() => fetchData(currentPage, searchTerm, false)} // 👈 pass this

      />
      <PayrollFilterDrawer
  open={filterDrawerOpen}
  onClose={() => setFilterDrawerOpen(false)}
  filters={filters}
  setFilters={setFilters}
  onApplyFilters={(newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
    fetchData(1, searchTerm, false, newFilters);
  }}
/>
    </Box>
  );
};

export default Payroll;
